module.exports = {
	"articleTitle1": "The Michigan Theater: Still timeless after more than 80 years ",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Tropical Smoothie Cafe",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/news/pocket-points-offers-students-incentives-stay-phones-class",
	"articleSnippet1": "Sep 14, 2015 ... ... 80 years of students like me, caring about our theater, our theater that now sits \nbetween an Elevation Burger and the Tropical Smoothie Café, ...",
	"articleSnippet2": "Feb 10, 2015 ... ... Comet Coffee, Get Some Burritos, Hunter House Hamburgers, Pita Kabob Grill, \nPita Pit, Sottini's Sub Shop and Tropical Smoothie Café.",
	"foodRecommendations": [
		{
			"text": "I really enjoy the Strawberry Limeade smoothie, but it's hard to go wrong with smoothies.",
			"person": "Erik Forkin"
		}
	],
	"articleTitle2": "Pocket Points application encourages student attention during class",
	"address": "607 E Liberty St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.279556,
		"lng": -83.741724
	},
	"totalMisc": 0,
	"categories": {
		"dessert": 1,
		"fooddrink": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/tropicalsmoothie.json
// module id = 991
// module chunks = 0